<template>
  <MainWrapper>
    <div class="companies-control-panel mb-30">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="companies-control-panel-inner">
              <router-link :to="'/companies/'+$route.params.slug+'/admin'" class="mr-20">
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'arrow-circle-left']" />
                <span class="dark-body-text panel-body-text">Назад к компании</span>
              </router-link>
              <router-link
                :to="'/companies/'+$route.params.slug+'/admin/specialists/'+$route.params.spec_slug+'/settings'"
                class="mr-20"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                <span class="dark-body-text panel-body-text">Основные настройки</span>
              </router-link>
              <router-link
                :to="'/companies/'+$route.params.slug+'/admin/specialists/'+$route.params.spec_slug+'/schedule'"
                class="mr-20"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'cog']" />
                <span class="dark-body-text panel-body-text">Настройки расписания</span>
              </router-link>
              <router-link
                :to="'/companies/'+$route.params.slug+'/admin/specialists/'+$route.params.spec_slug"
                class="mr-20"
              >
                <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-alt']" />
                <span class="dark-body-text panel-body-text">Календарь</span>
              </router-link>
              <div class="pointer pull-right">
                <span class="dark-body-text panel-body-text">{{ specInfo.full_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h3 class="mb-30">Настройки расписания</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="white-panel pt-20 pb-20 pr-20 pl-20">
              <div class="tabs">
                <router-link
                  :to="'/companies/'+$route.params.slug+'/admin/specialists/'+$route.params.spec_slug+'/schedule'"
                  class="tab pb-15 mr-30 inline-block"
                >
                  <h4 @click="actionTab = 'schedule'">Настройки расписания</h4>
                </router-link>
                <router-link
                  :to="'/companies/'+$route.params.slug+'/admin/specialists/'+$route.params.spec_slug+'/schedule#weekend'"
                  class="tab pb-15 mr-30 inline-block"
                >
                  <h4 @click="actionTab = 'weekend'">Выходные дни</h4>
                </router-link>
                <router-link
                  :to="'/companies/'+$route.params.slug+'/admin/specialists/'+$route.params.spec_slug+'/schedule#exception'"
                  class="tab pb-15 mr-30 inline-block"
                >
                  <h4 @click="actionTab = 'exception'">Время исключения</h4>
                </router-link>
                <div class="light-gray-line"></div>
              </div>
            </div>
            <div v-if="actionTab === 'exception'" class="white-panel pt-20 pb-20 pr-20 pl-20 mb-30">
              <!--h3 class="mb-30">Настройка дней исключений</h3-->
              <div
                v-if="exceptions"
                v-for="e, i in exceptions"
                :key="i"
                class="input-wrapper mb-15"
              >
                <div class="mr-15 inline-block">
                  <input
                    class="rounded-input"
                    type="text"
                    :value="e.date_time"
                    style="width:170px;background:#f2f2f2"
                    disabled
                  />
                </div>
                <div class="mr-15 inline-block">
                  <div>
                    <input
                      class="rounded-input mr-10"
                      type="text"
                      :value="e.start_time"
                      style="width:107px;background:#f2f2f2"
                      disabled
                    />
                    <input
                      class="rounded-input"
                      type="text"
                      :value="e.end_time"
                      style="width:107px;background:#f2f2f2"
                      disabled
                    />
                  </div>
                </div>
                <div class="mr-15 inline-block">
                  <input
                    v-model="e.info"
                    class="rounded-input"
                    type="text"
                    placeholder="Описание"
                    style="width:400px;background:#f2f2f2"
                    disabled
                  />
                </div>
                <Button @click="unsetException(e.id)" type="gray" text="Удалить" />
              </div>
              <div class="input-wrapper mb-15">
                <div class="mr-15 inline-block">
                  <!--span class="block mb-10">Дата</span-->
                  <input
                    v-model="exception_date_time"
                    class="rounded-input"
                    type="date"
                    placeholder="Дата"
                    style="width:170px"
                  />
                </div>
                <div class="mr-15 inline-block">
                  <!--span class="block mb-10">Временной промежуток</span-->
                  <div>
                    <vue-timepicker
                      :format="'HH:mm'"
                      v-model="exception_start_time"
                      class="rounded-input mr-10"
                    ></vue-timepicker>
                    <vue-timepicker
                      :format="'HH:mm'"
                      v-model="exception_end_time"
                      class="rounded-input"
                    ></vue-timepicker>
                  </div>
                </div>
                <div class="mr-15 inline-block">
                  <!--span class="block mb-10">Описание</span-->
                  <input
                    v-model="exception_info"
                    class="rounded-input"
                    type="text"
                    placeholder="Описание"
                    style="width:400px"
                  />
                </div>
                <Button @click="setException" type="blue" text="Добавить" />
              </div>
            </div>
            <div v-if="actionTab === 'weekend'" class="white-panel pt-20 pb-20 pr-20 pl-20 mb-30">
              <!--h3 class="mb-30">Настройка выходных дней</h3-->
              <div v-if="weekends" v-for="w, i in weekends" :key="i" class="input-wrapper mb-15">
                <input
                  class="rounded-input mr-15"
                  type="text"
                  :value="w.date_time"
                  style="width:170px;background:#f2f2f2"
                  disabled
                />
                <input
                  class="rounded-input mr-15"
                  type="text"
                  :value="w.info"
                  style="width:400px;background:#f2f2f2"
                  disabled
                />
                <Button @click="unsetWeekend(w.id)" type="gray" text="Удалить" />
              </div>
              <div class="input-wrapper mb-15">
                <input
                  v-model="weekend_date_time"
                  class="rounded-input mr-15"
                  type="date"
                  placeholder="Дата"
                  style="width:170px"
                />
                <input
                  v-model="weekend_info"
                  class="rounded-input mr-15"
                  type="text"
                  placeholder="Описание"
                  style="width:400px"
                />
                <Button @click="setWeekend" type="blue" text="Добавить" />
              </div>
            </div>
            <div
              v-if="actionTab === 'schedule'"
              class="white-panel pt-20 pb-20 pr-20 pl-20 mb-30"
              v-for="(w, i) in weeks"
              :key="i"
            >
              <!--h3 class="mb-30">Настройка расписания</h3-->
              <span class="dark-body-text block mb-15">Дата начала расписания</span>
              <input
                v-model="schedule_start_date"
                class="rounded-input mb-30"
                type="text"
                style="width:170px;background:#f2f2f2"
                disabled
              />
              <div class="settings-day" v-for="(d, k) in w" :key="k">
                <div class="mb-15 flexit">
                  <div
                    class="checkbox mr-10"
                    :class="{ pressed: d.checked }"
                    @click="d.checked = !d.checked"
                  >
                    <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                  </div>
                  <span class="dark-body-text">{{ d.day }}</span>
                </div>
                <div v-if="d.checked" class="flexit-start mb-15">
                  <div class="mr-30 inline-block">
                    <span class="block mb-10">Время работы</span>
                    <div>
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="d.time.start_time"
                        class="rounded-input mr-15"
                      ></vue-timepicker>
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="d.time.end_time"
                        class="rounded-input"
                      ></vue-timepicker>
                    </div>
                  </div>
                  <div class="mr-30 inline-block">
                    <span class="block mb-10">Живая очередь</span>
                    <div class="flexit">
                      <div
                        class="checkbox mr-15 inline-block"
                        :class="{ pressed: d.live_record }"
                        @click="d.live_record = !d.live_record"
                      >
                        <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                      </div>
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="d.live.start_time"
                        class="rounded-input mr-10"
                      ></vue-timepicker>
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="d.live.end_time"
                        class="rounded-input"
                      ></vue-timepicker>
                    </div>
                  </div>
                  <div class="inline-block">
                    <span class="block mb-10">Обеденный перерыв</span>
                    <div class="flexit">
                      <div
                        class="checkbox mr-15 inline-block"
                        :class="{ pressed: d.lunch }"
                        @click="d.lunch = !d.lunch"
                      >
                        <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                      </div>
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="d.lunch_settings.start_time"
                        class="rounded-input mr-10"
                      ></vue-timepicker>
                      <vue-timepicker
                        :format="'HH:mm'"
                        v-model="d.lunch_settings.end_time"
                        class="rounded-input"
                      ></vue-timepicker>
                    </div>
                  </div>
                  <div v-if="d.checked && buffer === false" class="inline-block">
                    <span class="block mb-10">&nbsp;</span>
                    <div class="flexit">
                      <Button
                        text="Копировать"
                        class="ml-15"
                        type="gray"
                        @click="copyThisDay(d.week_day)"
                        style="height:36.59px"
                      />
                    </div>
                  </div>
                  <div v-if="d.checked && buffer === true" class="inline-block">
                    <span class="block mb-10">&nbsp;</span>
                    <div class="flexit">
                      <Button
                        text="Вставить"
                        class="ml-15"
                        type="blue"
                        @click="pasteThisDay(d.week_day)"
                        style="height:36.59px"
                      />
                    </div>
                  </div>
                </div>
                <div class="gray-line mb-15" v-if="k !== 6"></div>
              </div>
              <Button
                v-if="action === 'create'"
                text="Сохранить"
                @click="setSchedule"
                class="mt-40"
                type="blue"
              />
              <Button
                v-if="action === 'update'"
                text="Обновить"
                @click="updateSchedule"
                class="mt-40"
                type="blue"
              />
            </div>
            <div
              v-if="actionTab === 'schedule' && weeks.length == 0"
              class="white-panel pt-20 pb-20 pr-20 pl-20 mb-30"
            >
              <p class="dark-body-text mb-10">Добавить неделю</p>
              <p class="mb-20 gray-body-text">
                Вы можете кастомизировать ваше расписание на две и более недели
                <br />с разным режимом работы.
              </p>
              <Button class="blue" text="Добавить неделю" @click="weeks.push(week)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.spec-categories {
  padding: 20px 60px 30px 20px;
}

.flexit {
  display: flex;
  align-items: center;
}

.flexit-start {
  display: flex;
  align-items: flex-start;
}

.time-picker {
  width: 107px;
}

.spec-categories-header {
  display: flex;

  .spec-count {
    margin: 0 0 0 auto;
    color: $gray_text;
  }
}

.spec-categories-single {
  display: flex;
  align-items: center;

  >.icon {
    margin-left: auto;
    font-size: 16px;
  }
}

.companies-control-panel {
  margin-top: -30px;
  height: 56px;
  background: $black_text;

  .panel-body-text, .panel-icon {
    color: #fff;
  }

  .panel-icon {
    font-size: 16px;
  }

  &-inner {
    height: 56px;
    display: flex;
    align-items: center;

    >div {
      display: flex;
      align-items: center;
    }
  }

  input {
    width: 430px;
  }
}

.col-lg-1 {
  min-height: 0;
}

.arr-down {
  position: absolute;
  bottom: -2px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid $black_text;
  z-index: 4;
  left: 0;
  right: 0;
  margin: auto;
}

.pull-right {
  margin-left: auto;
}

.schedule-controls {
  display: flex;
  align-items: center;
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Specialist from "@/components/Specialist.vue";
import Paginator from "@/components/Paginator.vue";
import Schedule from "@/components/Schedule.vue";
import VueTimepicker from "vue2-timepicker";

import moment from "moment";

import http from "@/methods/http.ts";

@Component({
  components: {
    MainWrapper,
    Button,
    Specialist,
    Paginator,
    Schedule,
    VueTimepicker
  }
})
export default class CompanyAdmin extends Vue {
  moment = moment;

  specInfo = {
    rating: 0,
    categories: []
  };

  buffer = false;
  bufferDay = {};

  action = "create";
  specialist_slug = "";
  weeks = [];
  schedule_start_date = "";
  schedule_id = 0;
  schedule_company_name = "";

  actionTab = "schedule";
  weekends = [];
  weekend_date_time = "";
  weekend_info = "";

  exceptions = [];
  exception_date_time = "";
  exception_start_time = { HH: null, mm: null };
  exception_end_time = { HH: null, mm: null };
  exception_info = "";

  week = [
    {
      day: "Понедельник",
      week_day: "monday",
      checked: false,
      live_record: false,
      live: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch: false,
      time: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch_settings: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      }
    },
    {
      day: "Вторник",
      week_day: "tuesday",
      checked: false,
      live_record: false,
      live: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch: false,
      time: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch_settings: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      }
    },
    {
      day: "Среда",
      week_day: "wednesday",
      checked: false,
      live_record: false,
      live: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch: false,
      time: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch_settings: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      }
    },
    {
      day: "Четверг",
      week_day: "thursday",
      checked: false,
      live_record: false,
      live: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch: false,
      time: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch_settings: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      }
    },
    {
      day: "Пятница",
      week_day: "friday",
      checked: false,
      live_record: false,
      live: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch: false,
      time: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch_settings: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      }
    },
    {
      day: "Суббота",
      week_day: "saturday",
      checked: false,
      live_record: false,
      live: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch: false,
      time: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch_settings: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      }
    },
    {
      day: "Воскресенье",
      week_day: "sunday",
      checked: false,
      live_record: false,
      live: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch: false,
      time: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      },
      lunch_settings: {
        end_time: { HH: null, mm: null },
        start_time: { HH: null, mm: null }
      }
    }
  ];

  nextWeek() {
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .add(7, "d")
      .format("DD.MM.YYYY");
  }

  prevWeek() {
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .subtract(7, "d")
      .format("DD.MM.YYYY");
  }

  firstDay = moment().format("DD.MM.YYYY");

  copyThisDay(week_day) {
    this.buffer = true;
    this.weeks.map(w => {
      w.map(d => {
        if (d.week_day === week_day) {
          console.log({ d, copy: true })
          this.bufferDay = d;
        }
      });
    });
  }

  pasteThisDay(week_day) {
    console.log({ weeks: this.weeks })
    this.weeks = this.weeks.map(w => {
      return w.map(d => {
        if (d.week_day === week_day) {
          d = {
            ...this.bufferDay,
            day: d.day,
            week_day: d.week_day,
            time: {
              ...this.bufferDay.time,
              start_time: {
                ...this.bufferDay.time.start_time
              },
              end_time: {
                ...this.bufferDay.time.end_time
              }
            },
            live: {
              ...this.bufferDay.live,
              start_time: {
                ...this.bufferDay.live.start_time
              },
              end_time: {
                ...this.bufferDay.live.end_time
              }
            },
            lunch_settings: {
              ...this.bufferDay.lunch_settings,
              start_time: {
                ...this.bufferDay.lunch_settings.start_time
              },
              end_time: {
                ...this.bufferDay.lunch_settings.end_time
              }
            }
          }
          console.log({ d, paste: true })
        }
        return d
      });
    });
    this.bufferDay = {};
    this.buffer = false;
  }

  getSpecInfo() {
    http(`masters/${this.$route.params.spec_slug}`, "get", false, {}).then(
      r => {
        this.specInfo = r.data;
        this.getSchedule();
        this.getWeekends();
        this.getExceptions();
      }
    );
  }

  setSchedule() {
    let error = false;
    const data = [];
    this.weeks.map(w => {
      w.map(d => {
        if (d.checked) {
          const day = {};
          if (
            d.time.start_time["HH"] === null ||
            d.time.start_time["HH"] === "" ||
            d.time.start_time["mm"] === null ||
              d.time.start_time["mm"] === "" ||
            d.time.end_time["HH"] === null ||
              d.time.end_time["HH"] === "" ||
              d.time.end_time["mm"] === null || d.time.end_time["mm"] === ""
          ) {
            error = true;
            return false;
          } else {
            day.time = {
              start_time: `${d.time.start_time["HH"]}:${d.time.start_time["mm"]}`,
              end_time: `${d.time.end_time["HH"]}:${d.time.end_time["mm"]}`
            };
          }
          if (d.lunch) {
            if (
              d.lunch_settings.start_time["HH"] === null ||
              d.lunch_settings.start_time["HH"] === "" ||
              d.lunch_settings.start_time["mm"] === null ||
                d.lunch_settings.start_time["mm"] === "" ||
              d.lunch_settings.end_time["HH"] === null ||
                d.lunch_settings.end_time["HH"] === "" ||
                d.lunch_settings.end_time["mm"] === null ||
                  d.lunch_settings.end_time["mm"] === ""
            ) {
              error = true;
              return false;
            } else {
              day.lunch_settings = {
                start_time: `${d.lunch_settings.start_time["HH"]}:${d.lunch_settings.start_time["mm"]}`,
                end_time: `${d.lunch_settings.end_time["HH"]}:${d.lunch_settings.end_time["mm"]}`
              };
            }
          }
          if (d.live_record) {
            if (
              d.live.start_time["HH"] === null ||
              d.live.start_time["HH"] === "" ||
              d.live.start_time["mm"] === null ||
                d.live.start_time["mm"] === "" ||
              d.live.end_time["HH"] === null ||
                d.live.end_time["HH"] === "" ||
                d.live.end_time["mm"] === null || d.live.end_time["mm"] === ""
            ) {
              error = true;
              return false;
            } else {
              day.live = {
                start_time: `${d.live.start_time["HH"]}:${d.live.start_time["mm"]}`,
                end_time: `${d.live.end_time["HH"]}:${d.live.end_time["mm"]}`
              };
            }
          }
          day.live_record = d.live_record;
          day.week_day = d.week_day;
          data.push(day);
        }
      });
    });

    if (error === true) {
      this.$store.commit("notificate", {
        text: "schedule error",
        type: "error"
      });
      return false;
    }

    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/schedule/create";
    http(url, "post", this.$store.state.token, {
      times: data
    }).then(
      r => {
        this.$store.commit("notificate", {
          type: "action",
          text: "Расписание сохранено."
        });
      },
      err => {
        this.$store.commit("notificate", {
          type: "alert",
          text:
            "Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз."
        });
      }
    );
  }

  getSchedule() {
    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/schedule";
    http(url, "get", false, {}).then(
      r => {
        if (r.data.length > 0) {
          this.schedule_id = r.data[0].id;
          this.schedule_start_date = r.data[0].start_date;
          this.schedule_company_name = r.data[0].company_name;
          let pattern = [
            {
              day: "Понедельник",
              week_day: "monday",
              checked: false,
              live_record: false,
              live: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch: false,
              time: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch_settings: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              }
            },
            {
              day: "Вторник",
              week_day: "tuesday",
              checked: false,
              live_record: false,
              live: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch: false,
              time: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch_settings: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              }
            },
            {
              day: "Среда",
              week_day: "wednesday",
              checked: false,
              live_record: false,
              live: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch: false,
              time: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch_settings: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              }
            },
            {
              day: "Четверг",
              week_day: "thursday",
              checked: false,
              live_record: false,
              live: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch: false,
              time: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch_settings: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              }
            },
            {
              day: "Пятница",
              week_day: "friday",
              checked: false,
              live_record: false,
              live: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch: false,
              time: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch_settings: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              }
            },
            {
              day: "Суббота",
              week_day: "saturday",
              checked: false,
              live_record: false,
              live: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch: false,
              time: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch_settings: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              }
            },
            {
              day: "Воскресенье",
              week_day: "sunday",
              checked: false,
              live_record: false,
              live: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch: false,
              time: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              },
              lunch_settings: {
                end_time: { HH: null, mm: null },
                start_time: { HH: null, mm: null }
              }
            }
          ];
          moment.lang("ru");
          let k = -1;
          r.data.forEach(function(elm) {
            elm.times.forEach(function(el) {
              if (el.week_day === "monday") {
                k = 0;
              }
              if (el.week_day === "tuesday") {
                k = 1;
              }
              if (el.week_day === "wednesday") {
                k = 2;
              }
              if (el.week_day === "thursday") {
                k = 3;
              }
              if (el.week_day === "friday") {
                k = 4;
              }
              if (el.week_day === "saturday") {
                k = 5;
              }
              if (el.week_day === "sunday") {
                k = 6;
              }
              pattern[k].checked = true;
              //pattern[k].live_record = el.live_record;
              pattern[k].time.start_time = {
                HH: moment(el.time.start_time, "HH:mm:ss").format("HH"),
                mm: moment(el.time.start_time, "HH:mm:ss").format("mm")
              };
              pattern[k].time.end_time = {
                HH: moment(el.time.end_time, "HH:mm:ss").format("HH"),
                mm: moment(el.time.end_time, "HH:mm:ss").format("mm")
              };
              if (el.lunch_settings) {
                pattern[k].lunch = true;
                pattern[k].lunch_settings.start_time = {
                  HH: moment(el.lunch_settings.start_time, "HH:mm:ss").format(
                    "HH"
                  ),
                  mm: moment(el.lunch_settings.start_time, "HH:mm:ss").format(
                    "mm"
                  )
                };
                pattern[k].lunch_settings.end_time = {
                  HH: moment(el.lunch_settings.end_time, "HH:mm:ss").format(
                    "HH"
                  ),
                  mm: moment(el.lunch_settings.end_time, "HH:mm:ss").format(
                    "mm"
                  )
                };
              } else {
                pattern[k].lunch = false;
              }

              if (el.live_record) {
                pattern[k].live_record = true;
                pattern[k].live.start_time = {
                  HH: moment(el.live.start_time, "HH:mm:ss").format("HH"),
                  mm: moment(el.live.start_time, "HH:mm:ss").format("mm")
                };
                pattern[k].live.end_time = {
                  HH: moment(el.live.end_time, "HH:mm:ss").format("HH"),
                  mm: moment(el.live.end_time, "HH:mm:ss").format("mm")
                };
              } else {
                pattern[k].live_record = false;
              }
            });
          });
          this.weeks.push(pattern);
          this.action = "update";
        }
      },
      err => {
        this.$store.commit("notificate", {
          type: "alert",
          text:
            "Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз."
        });
      }
    );
  }

  updateSchedule() {
    let error = false;
    const data = [];
    this.weeks.map(w => {
      w.map(d => {
        if (d.checked) {
          const day = {};
          if (
            d.time.start_time["HH"] === null ||
            d.time.start_time["HH"] === "" ||
            d.time.start_time["mm"] === null ||
              d.time.start_time["mm"] === "" ||
            d.time.end_time["HH"] === null ||
              d.time.end_time["HH"] === "" ||
              d.time.end_time["mm"] === null || d.time.end_time["mm"] === ""
          ) {
            error = true;
            return false;
          } else {
            day.time = {
              start_time: `${d.time.start_time["HH"]}:${d.time.start_time["mm"]}`,
              end_time: `${d.time.end_time["HH"]}:${d.time.end_time["mm"]}`
            };
          }
          if (d.live_record) {
            if (
              d.live.start_time["HH"] === null ||
              d.live.start_time["HH"] === "" ||
              d.live.start_time["mm"] === null ||
                d.live.start_time["mm"] === "" ||
              d.live.end_time["HH"] === null ||
                d.live.end_time["HH"] === "" ||
                d.live.end_time["mm"] === null || d.live.end_time["mm"] === ""
            ) {
              error = true;
              return false;
            } else {
              day.live = {
                start_time: `${d.live.start_time["HH"]}:${d.live.start_time["mm"]}`,
                end_time: `${d.live.end_time["HH"]}:${d.live.end_time["mm"]}`
              };
            }
          }
          if (d.lunch) {
            if (
              d.lunch_settings.start_time["HH"] === null ||
              d.lunch_settings.start_time["HH"] === "" ||
              d.lunch_settings.start_time["mm"] === null ||
                d.lunch_settings.start_time["mm"] === "" ||
              d.lunch_settings.end_time["HH"] === null ||
                d.lunch_settings.end_time["HH"] === "" ||
                d.lunch_settings.end_time["mm"] === null ||
                  d.lunch_settings.end_time["mm"] === ""
            ) {
              error = true;
              return false;
            } else {
              day.lunch_settings = {
                start_time: `${d.lunch_settings.start_time["HH"]}:${d.lunch_settings.start_time["mm"]}`,
                end_time: `${d.lunch_settings.end_time["HH"]}:${d.lunch_settings.end_time["mm"]}`
              };
            }
          }
          day.live_record = d.live_record;
          day.week_day = d.week_day;
          data.push(day);
        }
      });
    });

    if (error === true) {
      this.$store.commit("notificate", {
        text: "schedule error",
        type: "error"
      });
      return false;
    }

    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/schedule/update";
    http(url, "post", this.$store.state.token, {
      id: this.schedule_id,
      times: data,
      start_date: this.schedule_start_date,
      company_name: this.schedule_company_name
    }).then(
      r => {
        this.$store.commit("notificate", {
          type: "action",
          text: "Расписание сохранено."
        });
      },
      err => {
        this.$store.commit("notificate", {
          type: "alert",
          text:
            "Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз."
        });
      }
    );
  }

  getExceptions() {
    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/exceptions";
    http(url, "get", this.$store.state.token, {}).then(
      r => {
        this.exceptions = r.data;
      },
      err => {
        this.$store.commit("notificate", {
          type: "alert",
          text:
            "Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз."
        });
      }
    );
  }

  setException() {
    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/exception/create";
    http(url, "post", this.$store.state.token, {
      date_time: this.exception_date_time,
      start_time:
        this.exception_start_time["HH"] + ":" + this.exception_start_time["mm"],
      end_time:
        this.exception_end_time["HH"] + ":" + this.exception_end_time["mm"],
      info: this.exception_info
    })
      .then(r => {
        this.exception_date_time = "";
        this.exception_start_time = { HH: null, mm: null };
        this.exception_end_time = { HH: null, mm: null };
        this.exception_info = "";
        this.$store.commit("notificate", {
          type: "action",
          text: "День исключения сохранен."
        });
        this.getExceptions();
      })
      .catch(error => {
        this.$store.commit("notificate", {
          text: error.response.data.message,
          type: "error"
        });
      });
  }

  unsetException(id) {
    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/exception/delete";
    http(url, "delete", this.$store.state.token, {
      id: id
    })
      .then(r => {
        this.$store.commit("notificate", {
          type: "action",
          text: "День исключения удален."
        });
        this.getExceptions();
      })
      .catch(error => {
        this.$store.commit("notificate", {
          text: error.response.data.message,
          type: "error"
        });
      });
  }

  getWeekends() {
    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/weekends";
    http(url, "get", false, {}).then(
      r => {
        this.weekends = r.data;
      },
      err => {
        this.$store.commit("notificate", {
          type: "alert",
          text:
            "Что-то пошло не так. Пожалуйста, проверьте введенные данные и попробуйте ещё раз."
        });
      }
    );
  }

  setWeekend() {
    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/weekend/create";
    http(url, "post", this.$store.state.token, {
      date_time: this.weekend_date_time,
      info: this.weekend_info
    })
      .then(r => {
        this.weekend_date_time = "";
        this.weekend_info = "";
        this.$store.commit("notificate", {
          type: "action",
          text: "Выходной день сохранен."
        });
        this.getWeekends();
      })
      .catch(error => {
        this.$store.commit("notificate", {
          text: error.response.data.message,
          type: "error"
        });
      });
  }

  unsetWeekend(id) {
    let url =
      "companies/" +
      this.$route.params.slug +
      "/masters/" +
      this.$route.params.spec_slug +
      "/weekend/delete";
    http(url, "delete", this.$store.state.token, {
      id: id
    })
      .then(r => {
        this.$store.commit("notificate", {
          type: "action",
          text: "Выходной день удален."
        });
        this.getWeekends();
      })
      .catch(error => {
        this.$store.commit("notificate", {
          text: error.response.data.message,
          type: "error"
        });
      });
  }

  created() {
    let hash = this.$router.history.current.hash;
    hash = hash.replace("#", "");
    if (hash !== "") {
      this.actionTab = hash;
    }
  }

  mounted() {
    this.getSpecInfo();
  }
}
</script>